import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FaqFilter } from '../../shared/types/FaqFiltersDto';
import { FaqService } from '../faq.service';

@Component({
  selector: 'lp2-faq-filter',
  templateUrl: './faq-filter.component.html',
  styleUrls: ['./faq-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FaqFilterComponent {
  @Input() filters: Array<FaqFilter>;
  @Input() textFilter: string;

  constructor(private faqService: FaqService) { }

  onFilterChange(category: string) {
    this.faqService.onFilterChange(category);
  }

  submitTextFilter(inputValue: string) {
    this.faqService.onTextFilterChange(inputValue);
  }
}



// WEBPACK FOOTER //
// ./ts/app/faq/faq-filter/faq-filter.component.ts